import { SHIPMENT_TRANSITIONS } from '@befret/core/shipment';

/**
 * #2292 — où en est un colis au Congo, vu de la livraison. La matrice serveur reste
 * seule juge : `delivered` n'est accepté que depuis ses statuts, et elle ne s'élargit
 * pas, sinon un colis serait « livré » sans jamais avoir été « en cours de livraison ».
 */
const DELIVERABLE_STATUSES: ReadonlySet<string> = new Set(SHIPMENT_TRANSITIONS.delivered?.from ?? []);

/** Pas encore partis : le passage en livraison se fait depuis « Tri livraison », partenaire ou non. */
const AWAITING_ASSIGNMENT_STATUSES: ReadonlySet<string> = new Set(['local_sorting', 'delivery_sorted']);

export function canConfirmDelivery(statusCurrent: string | null | undefined): boolean {
  return DELIVERABLE_STATUSES.has(statusCurrent ?? '');
}

export function isAwaitingDeliveryAssignment(statusCurrent: string | null | undefined): boolean {
  return AWAITING_ASSIGNMENT_STATUSES.has(statusCurrent ?? '');
}

/**
 * La liste « Tri livraison ». Un partenaire déjà posé n'en sort un colis que s'il est
 * parti : posé sans changer le statut, il rendait le colis inassignable et inlivrable.
 */
export function isInDeliverySorting(data: any): boolean {
  if (data['delivery']?.['partnerId'] && !isAwaitingDeliveryAssignment(data['status']?.['current'])) return false;
  // Colis bloqués au dégroupage.
  if (data['congoArrival']?.['parcelStatus'] === 'blocked') return false;
  // Seuls les colis passés au dégroupage (scannés), ou sans groupage.
  const hasContainer = !!data['expedition']?.['containerId'];
  if (hasContainer && !data['congoArrival']?.['scannedAt']) return false;
  return true;
}

/** Le serveur a refusé la transition : la même demande échouera de la même façon. */
export function isIllegalTransitionRefusal(err: any): boolean {
  return err?.code === 'functions/failed-precondition' && String(err?.message ?? '').includes('illegal_from');
}
